import type { NotifyPort } from '@/features/messages/domain/notify'
import type { CustomerLookupPort, WorkflowCustomer } from '../domain/workflow'

const listCustomers = async (
	port: CustomerLookupPort,
	query: string | null,
	notify: NotifyPort,
): Promise<WorkflowCustomer[]> => {
	try {
		return await port.listCustomers(query)
	} catch {
		notify.error('workflow.customersLoadFailed')
		return []
	}
}

export { listCustomers }
